import React from 'react'

export const CalendarIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.88889 1V4.2M11.1111 1V4.2M1 7.4H15M5.66667 12.2L7.22222 13.8L10.3333 10.6M2.55556 2.6H13.4444C14.3036 2.6 15 3.31634 15 4.2V15.4C15 16.2837 14.3036 17 13.4444 17H2.55556C1.69645 17 1 16.2837 1 15.4V4.2C1 3.31634 1.69645 2.6 2.55556 2.6Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
